import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAnalytics from '../../../../../../hooks/maestro/useAnalytics';
import ComparisonMarkingContainer from './ComparisonMarking';
import StudentDistributionContainer from './StudentDistribution';
import Title from './Title';
import { useNavigate, useParams } from 'react-router-dom';
import useMarking from '../../../../../../hooks/maestro/useMarking';
import { handlerErrorV2 } from '../../../../../../utils/errors';
import { updateClassMarkingCompletedType } from '../../../../../../store/actions/class-marking.actions';

const Dashboard = () => {
  const [datasets, setDatasets] = useState({});
  const [error, setError] = useState(null);
  const [isLoading, toggleLoading] = useState(false);
  const lcIds = useSelector((state) => state?.classMarking?.dashboard?.lcIds || []);
  const lcId = lcIds[0] || null;

  const navigate = useNavigate();
  const { classId, studentId, curriculumId, ulId } = useParams();
  const redirectStudentId = studentId ? `${studentId}/` : '';
  const { getStudentMarkingByClassIdAndUlId } = useMarking();
  const dispatch = useDispatch();

  const onStudentView = (student, type) => {
    student._id = student.studentId;
    getStudentMarkingByClassIdAndUlId(student);
    if (type) {
      dispatch(updateClassMarkingCompletedType(type));
    }
    navigate(
      `/dashboard/${redirectStudentId}classes/${curriculumId}/preview/${classId}/unit-of-learning/${ulId}/student-view`
    );
  };

  const { updateInfoDashboard } = useAnalytics();

  const loadData = useCallback(async () => {
    if (lcId) {
      try {
        toggleLoading(true);
        const response = await updateInfoDashboard(lcId);
        setDatasets(response?.data);
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        toggleLoading(false);
      }
    }
  }, [lcId]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <>
      <div className='absolute left-0px right-0px -top-1px h-14'>
        <Title isLoading={isLoading} />
      </div>
      <div className='grid grid-cols-2 gap-2 h-full'>
        <div className='relative'>
          <div className='absolute left-0px right-0 bottom-0 top-14 bg-background'>
            <ComparisonMarkingContainer
              onStudentView={onStudentView}
              isLoading={isLoading}
              datasets={datasets}
            />
          </div>
        </div>
        <div className='relative'>
          <div className='absolute left-0px right-0 bottom-0 top-14 bg-background'>
            <StudentDistributionContainer
              onStudentView={onStudentView}
              isLoading={isLoading}
              datasets={datasets}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
